import { getQueryParamValue } from 'src/lib/browser';
import { ROUTE_PARAMS } from 'src/routes';

export const getCustomMultiPromptGroupQueryParam = () =>
  getQueryParamValue(ROUTE_PARAMS.customMultiPromptGroup);
